import React, { useContext } from "react";
import path from "path";
import BrowserStorage from "../../../../../config/core/BrowserStorage";
import { ImageContext } from "../../../provider";

interface Props {
  onClick: any;
}

function IGLoginBtn({ onClick }: Props): JSX.Element {
  const { instagramLogin } = useContext(ImageContext);

  function handleClick() {
    onClick();
    if (!BrowserStorage.getStorageItem("igAuthData")) {
      instagramLogin();
    }
  }

  return (
    <button
      onClick={handleClick}
      className={"btn product-canvas__btn-wide mb-2"}
      type={"button"}>
      <img
        src={path.resolve(`${window.basePath}/images/instagram.svg`)}
        alt={""}
      />
      <p>Instagram</p>
    </button>
  );
}

export default IGLoginBtn;
